module.exports = __webpack_public_path__ + "static/bmx-rider-702735bd60ce567cbacd980fc9133331.png";